/**
 * Mobile Menu - Navigation Handler
 *
 * Clean, event-driven mobile menu
 * Uses CSS classes for state management (no inline styles)
 */

document.addEventListener('DOMContentLoaded', function() {
    const menuToggle = document.querySelector('.mobile-menu-toggle');
    const menuOverlay = document.querySelector('.mobile-menu-overlay');
    const menuClose = document.querySelector('.mobile-menu-close');
    const mobileMenu = document.querySelector('.mobile-menu');

    if (!menuToggle || !menuOverlay || !menuClose || !mobileMenu) {
        return;
    }

    function openMenu() {
        menuOverlay.classList.add('active');
        document.documentElement.classList.add('no-scroll');
        document.body.classList.add('no-scroll');

        // Update ARIA states for screen readers
        menuToggle.setAttribute('aria-expanded', 'true');
        mobileMenu.setAttribute('aria-hidden', 'false');
    }

    function closeMenu() {
        // Move focus OUT before hiding (prevents aria-hidden blocking)
        menuToggle.focus();

        menuOverlay.classList.remove('active');
        document.documentElement.classList.remove('no-scroll');
        document.body.classList.remove('no-scroll');

        // Update ARIA states for screen readers
        menuToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
    }

    // Open menu
    menuToggle.addEventListener('click', openMenu);

    // Close menu (X button)
    menuClose.addEventListener('click', closeMenu);

    // Close menu (click on overlay)
    menuOverlay.addEventListener('click', function(e) {
        if (e.target === menuOverlay) {
            closeMenu();
        }
    });

    // Close menu with ESC key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && menuOverlay.classList.contains('active')) {
            closeMenu();
        }
    });
});
